<template>
  <!-- <div id="content-wrapper1">
    <p>尊敬的用户：</p>
    <p>我们非常高兴地宣布，我们的WiT VIP即将进行升级。这次升级将带来更好的性能和更丰富的功能，以更好地满足您的需求。</p>
    <p>
      在升级过程中，我们将尽最大努力确保服务的正常运行。但是，在升级期间，您可能会暂时遇到某些服务不可用或延迟等情况。我们深表歉意，并承诺尽快恢复正常服务。我们将在升级完成后再次通知您。
    </p>
    <p>
      我们一直致力于为用户提供最好的服务和体验，这次升级将是我们实现这一目标的重要一步。我们相信，在新的平台上，您将能够体验到更好的性能、更多的功能和更好的使用体验。
    </p>
    <p>感谢您一直以来对我们的支持和信任。我们期待在升级后为您提供更好的服务！</p>
  </div> -->
  <div id="content-wrapper2"> 
    <p>尊敬的用户：</p>
    <p>我们很高兴地宣布，我们的WiT VIP现已拓展到微信小程序！您可以在手机上随时随地使用我们的服务，体验更加方便快捷。您可以通过扫描下方微信小程序二维码，或者搜索小程序名称“明基照明”进入小程序。</p>
    <p>
      我们一直致力于提供最好的用户体验，将服务拓展到小程序平台是我们迈出的重要一步。我们相信这将更好地满足您的需求，带来更加便捷的使用体验。
    </p>
    <p>
      感谢您一直以来的支持！我们期待在WiT VIP上为您提供更好的服务。
    </p>
    <p>
      <img src="../assets/img/mini-qrcode.jpg">
    </p>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
#content-wrapper1 {
  width: 80%;
  position: relative;
  margin: 50px auto;
  p {
    text-align: justify;
  }
}
#content-wrapper2 {
  width: 80%;
  position: relative;
  margin: 50px auto;
  p {
    text-align: justify;
    &:last-child {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 100px;
      img {
        width: 70%;
        height: auto;
      }
    }
  }
}
</style>
